import script from "./MainReg.vue?vue&type=script&setup=true&lang=js"
export * from "./MainReg.vue?vue&type=script&setup=true&lang=js"

import "./MainReg.vue?vue&type=style&index=0&id=181b03f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-181b03f4"]])

export default __exports__